import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { Row, Column } from '@estee/elc-grid';
import { PRODUCT_GRID_HEADER, PRODUCT_GRID_SUBHEADER } from '~constants/DataTestIdAttributes';

interface IProductGridHeaders {
    productGridHeader?: string;
    productGridSubheader?: string;
    categoryHeaderTag?: string;
}

export const StyledHeaderColumn = styled(Column)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const productGridHeaderWrapper = classes('product-grid-header-wrapper');
const productGridHeaderClassnames = classes('product-grid-header');
const productGridSubheaderClassnames = classes('product-grid-subheader');

export const ProductGridHeaders = observer(function ProductGridHeaders(props: IProductGridHeaders) {
    const { productGridHeader, productGridSubheader, categoryHeaderTag } = props;

    if (!productGridHeader && !productGridSubheader) {
        return null;
    }

    // Determine which header element to use
    const getHeaderElement = () => {
        if (categoryHeaderTag && ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(categoryHeaderTag)) {
            return categoryHeaderTag;
        }
        return 'div';
    };

    const HeaderElement = getHeaderElement() as keyof JSX.IntrinsicElements;

    return (
        <Row>
            <StyledHeaderColumn className={productGridHeaderWrapper}>
                {productGridHeader && (
                    React.createElement(
                        HeaderElement,
                        {
                            'data-test-id': PRODUCT_GRID_HEADER,
                            className: productGridHeaderClassnames
                        },
                        productGridHeader
                    )
                )}
                {productGridSubheader && (
                    <div
                        data-test-id={PRODUCT_GRID_SUBHEADER}
                        className={productGridSubheaderClassnames}
                    >
                        {productGridSubheader}
                    </div>
                )}
            </StyledHeaderColumn>
        </Row>
    );
});
